import { render, staticRenderFns } from "./HelpLoginDescription.vue?vue&type=template&id=bb0d11c6&"
import script from "./HelpLoginDescription.vue?vue&type=script&lang=js&"
export * from "./HelpLoginDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports